const KEY = 'VT__locale_key_p0s-1'

export function getLocale() {
  const ret = window.localStorage.getItem(KEY)
  return ret || 'en_US'
}

export function setLocale(locale) {
  window.localStorage.setItem(KEY, locale)
}
